import { get } from "../services";

export const getAllCarousel = () => get("carousel/all");
